import request from "axios";
import { UpdateStatus, LoadingStatus } from "./enum";
import { removeRoundingErrors } from "./helpers";

const mapLocalApprovals = (localApprovedTimesheetRefs, rows) =>
  rows.map(row => {
    const updatedStatus =
      localApprovedTimesheetRefs.indexOf(row.timesheetRef) !== -1
        ? "Z30"
        : row.calculatedStatusCode;
    return {
      ...row,
      calculatedStatusCode: updatedStatus
    };
  });

export const getCSV = async (companyRef, userEmail, weekEndDate) => {
  const uEmail = encodeURIComponent(userEmail);
  const cRef = encodeURIComponent(companyRef);

  try {
    const response = await request.get(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/${cRef}/${uEmail}/${weekEndDate}/csv`,
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    );
    return response;
  } catch (e) {
    return e;
  }
};

export const approveTimesheet = (
  timesheetRef,
  setUpdateState,
  updateSheet,
  rows,
  setRows,
  userEmail
) => {
  setUpdateState(UpdateStatus.Loading);
  updateSheet(rows, setRows, timesheetRef, { pendingAuth: true });
  request
    .post(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/decision`,
      {
        timesheet: {
          ref: timesheetRef,
          status: "approved",
          notes: "",
          authorisedBy: userEmail,
          fromEmail: false
        }
      },
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    )
    .then(() => {
      updateSheet(rows, setRows, timesheetRef, {
        pendingAuth: false,
        authorised: true,
        authorisedBy: userEmail,
        calculatedStatusCode: "Z30"
      });
      setUpdateState(UpdateStatus.Success);
    })
    .catch(() => {
      updateSheet(rows, setRows, timesheetRef, {
        pendingAuth: false,
        authorised: false
      });
      setUpdateState(UpdateStatus.ErrorApprove);
    });
};

export const rejectTimesheet = (
  timesheetRef,
  setUpdateState,
  updateSheet,
  rows,
  setRows,
  rejectionReason,
  userEmail
) => {
  setUpdateState(UpdateStatus.Loading);
  request
    .post(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/decision`,
      {
        timesheet: {
          ref: timesheetRef,
          status: "rejected",
          notes: rejectionReason,
          authorisedBy: userEmail,
          fromEmail: false
        }
      },
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    )
    .then(() => {
      updateSheet(rows, setRows, timesheetRef, {
        pendingAuth: false,
        authorised: true,
        calculatedStatusCode: "Z10",
        rejected: true
      });
      setUpdateState(UpdateStatus.Rejected);
    })
    .catch(() => {
      updateSheet(rows, setRows, timesheetRef, {
        pendingAuth: false,
        authorised: false
      });
      setUpdateState(UpdateStatus.ErrorReject);
    });
};

export const loadTimesheet = async (
  weekEndDate,
  companyRef,
  userEmail,
  setRows,
  setLoading,
  initCostCentres
) => {
  const uEmail = encodeURIComponent(userEmail);
  const cRef = encodeURIComponent(companyRef);

  try {
    const { data } = await request.get(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/${cRef}/${uEmail}/${weekEndDate}`,
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    );
    await initCostCentres();
    setLoading(LoadingStatus.Success);
    if (data.timesheets) {
      setRows(
        mapLocalApprovals([], removeRoundingErrors(data.timesheets.incomplete))
      );
    }
  } catch (_error) {
    setLoading(LoadingStatus.Error);
  }
};

export const getSingleTimesheetFromEmail = async timesheetRef =>
  request
    .get(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/${timesheetRef}`,
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    )
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });

export const approveTimesheetFromEmail = (
  timesheetRef,
  setUpdateState,
  userEmail
) => {
  setUpdateState(UpdateStatus.Loading);
  request
    .post(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/decision`,
      {
        timesheet: {
          ref: timesheetRef,
          status: "approved",
          notes: "",
          authorisedBy: userEmail,
          fromEmail: true
        }
      },
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    )
    .then(() => {
      setUpdateState(UpdateStatus.Success);
    })
    .catch(error => {
      console.error(error.message);
      setUpdateState(UpdateStatus.ErrorApprove);
    });
};

export const rejectTimesheetFromEmail = (
  timesheetRef,
  setUpdateState,
  userEmail,
  rejectionReason
) => {
  setUpdateState(UpdateStatus.Loading);
  request
    .post(
      `${process.env.REACT_APP_FONT_API_ENDPOINT}/client-portal/timesheets/decision`,
      {
        timesheet: {
          ref: timesheetRef,
          status: "rejected",
          notes: rejectionReason,
          authorisedBy: userEmail,
          fromEmail: true
        }
      },
      {
        headers: { "x-api-key": `${process.env.REACT_APP_FONT_API_KEY}` }
      }
    )
    .then(() => {
      setUpdateState(UpdateStatus.Rejected);
    })
    .catch(error => {
      console.error(error.message);
      setUpdateState(UpdateStatus.ErrorReject);
    });
};
